import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;
const cobrancaURL = `${baseURL}/produto/cobranca`;

const getToken = () => {
  const rawToken =
    localStorage.getItem("jwtToken") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("jwtToken") ||
    sessionStorage.getItem("authToken") ||
    sessionStorage.getItem("token");

  if (!rawToken) throw new Error("Token não encontrado.");
  return rawToken.startsWith("Bearer ") ? rawToken.slice(7) : rawToken;
};

const getQueryParams = (params) => Object.fromEntries(
  Object.entries(params).reduce((entries, [key, value]) => {
    if (value === undefined || value === null || String(value).trim() === "") return entries;
    entries.push([key, typeof value === "string" ? value.trim() : value]);
    return entries;
  }, []),
);

const normalizePage = (data, requestedPage, requestedSize) => ({
  content: Array.isArray(data?.content) ? data.content : [],
  page: Number.isFinite(Number(data?.page)) ? Number(data.page) : requestedPage,
  size: Number.isFinite(Number(data?.size)) ? Number(data.size) : requestedSize,
  totalElements: Number(data?.totalElements) || 0,
  totalPages: Number(data?.totalPages) || 0,
});

const getPage = async (resource, params) => {
  const response = await axios.get(`${cobrancaURL}/${resource}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
    params: getQueryParams(params),
  });

  return normalizePage(response?.data, Number(params.page) || 0, Number(params.size) || 25);
};

const getApiErrorMessage = (err, fallbackMessage) => {
  const responseData = err?.response?.data;

  if (typeof responseData === "string" && responseData.trim()) return responseData;
  if (responseData?.mensagem) return responseData.mensagem;
  if (responseData?.message) return responseData.message;
  if (responseData?.erro) return responseData.erro;
  if (responseData?.detail) return responseData.detail;
  if (err?.response?.status === 400) return "Filtros inválidos. Revise os valores informados e tente novamente.";
  if (err?.response?.status === 401) return "Sessão expirada ou token inválido.";
  if (err?.response?.status === 403) return "Usuário sem acesso ativo ao produto Cobrança.";
  if (err?.response?.status >= 500) return "Ocorreu uma falha interna ao consultar os dados de Cobrança.";

  return fallbackMessage || err?.message || "Não foi possível consultar os dados de Cobrança.";
};

const getCargas = (params) => getPage("cargas", params);
const getTitulos = (params) => getPage("titulos", params);
const getParcelas = (params) => getPage("parcelas", params);

const cobrancaListagensService = {
  getApiErrorMessage,
  getCargas,
  getTitulos,
  getParcelas,
};

export default cobrancaListagensService;
